import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";
import { InstanceTypesResponse } from "pages/mlops/types";

export const getInstanceTypes = async (): Promise<InstanceTypesResponse> => {
  try {
    const data = await fetchService<InstanceTypesResponse>(API_PATHS.GET_INSTANCE_TYPES, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const validateEmail = async (email: string): Promise<{result: string}> => {
  try {
    const data = await fetchService<{result: string}>(API_PATHS.VALIDATE_EMAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: { email }
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

export function convertSnakeToTitleCase(input: string) {
  if (!input) { return ''; }
  return input
    .split('_')                            
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
    .join(' ');
}